import { FLOW_EXAMPLE_SLUG } from '@/lib/flow-templates/constants'
import {
  PUBLIC_FLOWS_PATH,
  publicFlowTemplatePath,
} from '@/lib/flow-templates/slug'
import { BREW_DEMO_BOOKING_URL } from '@/lib/site/booking'
import { siteConfig } from '@/lib/site/config'

/**
 * Every destination the home page links to. Templates, integrations and
 * flows link straight to their public `/browse/*` pages (crawlers and signed-out
 * visitors land without a redirect; `proxy.ts` sends signed-in visitors to
 * the in-app pages).
 */
export const HOME_LINKS = {
  signUp: '/sign-up',
  pricing: '/pricing',
  templates: '/browse/templates',
  /** Brew's own published welcome flow. */
  welcomeFlow: publicFlowTemplatePath(FLOW_EXAMPLE_SLUG, PUBLIC_FLOWS_PATH),
  integrations: '/browse/integrations',
  mcp: '/mcp',
  blog: '/blog',
  developers: '/developers',
  docs: 'https://docs.brew.new/',
  mcpDocs: 'https://docs.brew.new/api-reference/mcp/overview',
  bookCall: BREW_DEMO_BOOKING_URL,
  email: `mailto:${siteConfig.contact.email.support}`,
  phone: `tel:${siteConfig.contact.phone.replace(/[^+\d]/g, '')}`,
} as const
